import NewBooking from "../../components/booking/NewBooking.tsx";
import { useParams, useSearchParams } from "react-router";

function NewBookingPage() {
  const { teacherId } = useParams();
  const [searchParams] = useSearchParams();
  const locationId = searchParams.get("locationId");
  const instrument = searchParams.get("instrument");
  const locationType = searchParams.get("locationType");
  return (
    <div>
      <NewBooking
        teacherId={teacherId || ""}
        locationIdQuery={locationId}
        instrumentQuery={instrument}
        lessonTypeQuery={locationType}
      />
    </div>
  );
}

export default NewBookingPage;
